/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2024 (original work) Open Assessment Technologies SA
 *
 */

import { user as currentUserStore } from '@/stores/auth.store';
import { get } from 'svelte/store';
import config from '@/config';
import { handleRouteError } from './handleRouteError';

/**
 * @type Guard
 */
export const loginGuard = async (next, router) => {
    try {
        await currentUserStore.updateTokenData();
        const user = get(currentUserStore);
        if (!user) {
            // awaited so that a rejection further down the chain is caught below
            return await next();
        }

        return await router.redirect(config.routes.home);
    } catch (err) {
        await handleRouteError(err, router);
    }
};
